import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  HandleBaseMapDeletionModalContainer, type HandleBaseMapDeletionModalContainerProps,
} from './handleBaseMapDeletionModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BaseMapDeletionConflictResolution: HandleBaseMapDeletionModalContainerProps;
  }
}
modalRenderer.register('BaseMapDeletionConflictResolution', HandleBaseMapDeletionModalContainer);
